export const formatRows = (listaItems) =>
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    codigo: item.codigo_ramo || "Código no disponible",
    descripcion: item.descripcion_ramo || "Ramo no disponible",
  }));
